import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import StatusMultiple from "../../StatusMultiple";
import Autorizado from "../../Autorizado";
import { TableHeader, Pagination, Search } from "../../../DataTable"
import useFullPageLoader from "../../../hooks/useFullPageLoader"
import moment from 'moment';

import { v4 as uuidv4 } from "uuid";

function ListadoOrdenesCompra() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_HABILITACION = process.env.REACT_APP_URL_HABILITACION;
  const URL_TIPOS_TELAS = process.env.REACT_APP_URL_TIPOS_TELAS;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_TELAS_OC = process.env.REACT_APP_URL_TELAS_OC;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  // const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-60);

  let validaInter = new Date()
  validaInter.setDate(validaInter.getDate()+15);

  let validaNac = new Date()
  validaNac.setDate(validaNac.getDate()+8);
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");
  let validadorInter   = moment(validaInter).format("YYYY-MM-DD");
  let validadorNac   = moment(validaNac).format("YYYY-MM-DD");

  const [ordenesCompra, setOrdenesCompra] = useState([]);

  const [telas, setTelas] = useState([]);
  const [habilitacion, setHabilitacion] = useState([]);
  const [artOC, setArtOC] = useState([]);
  const [selectedTiposTelasFiltro, setSelectedTiposTelasFiltro] = useState("");
  const [colores, setColores] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");

  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  // const [clientes, setClientes] = useState([]);
  // const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [selectedFechaCompInicio, setSelectedFechaCompInicio] = useState("");
  const [selectedFechaCompFin, setSelectedFechaCompFin] = useState("");
  const [selectedTipo, setSelectedTipo] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [dirigido, setDirigido] = useState("");
  // L64 (2026-06) — lugar de entrega
  const [lugarEntrega, setLugarEntrega] = useState("NA");

  const [fecha, setFecha] = useState("");
  const [plazo, setPlazo] = useState("");
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  // const [fecha_cita, setFechaCita] = useState("");
  // const [fecha_cancelacion_pedido, setFechaCancelacionPedido] = useState("");
  // const [fecha_creacion_prepedido, setFechaCreacionPrePedido] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState("");
  const [total_kilos, setTotalUnidaKilos] = useState("");
  const [total_metros, setTotalUnidaMetros] = useState("");
  const [total_piezas, setTotalUnidaPiezas] = useState("");
  const [numero_orden, setNumeroOrden] = useState("");
  const [tipo, setTipo] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [selectedProveedorEdit, setSelectedProveedorEdit] = useState("");
  // const [selectedClienteEdit, setSelectedClienteEdit] = useState("");
  // const [selectedPendFechaConf, setSelectedPendFechaConf] = useState("");

  const [telasOrden, setTelasOrden] = useState([]);
  const [habilitacionOrden, setHabilitacionOrden] = useState([]);
  const [modalEditTelas, setModalEditTelas] = useState(false);
  const toggleEditTelas = () => setModalEditTelas(!modalEditTelas);
  const [modalEditHabilitacion, setModalEditHabilitacion] = useState(false);
  const toggleEditHabilitacion = () => setModalEditHabilitacion(!modalEditHabilitacion);
  const [total_general_edit, setTotalGeneralEdit] = useState(0);
  const [total_kilos_edit, setTotalKilosEdit] = useState(0);
  const [total_metros_edit, setTotalMetrosEdit] = useState(0);
  const [total_piezas_edit, setTotalPiezasEdit] = useState(0);
  const [totalIVA, setTotalIVA] = useState(0);
  const [IVA, setIVA] = useState(0);


  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      telas: "",
      unidad: 0,
      colores: "",
      // arrayColoresTela:[],
      cantidad: 0,
      precio: 0,
      descuento: 0,
      total: 0,
      observaciones: "NA"
    },
  ]);

  const [inputFieldsHab, setInputFieldsHab] = useState([
    {
      id: uuidv4(),
      habilitacion: "",
      unidad: 0,
      cantidad: 0,
      precio: 0,
      descuento: 0,
      total: 0,
      observaciones: "NA"
    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [status, setStatus] = useState('Abierto');
  const [autorizado, setAutorizado] = useState('');

    //--- Pagination
  const [comments, setComments] = useState([]);
  // (2026-08) { idOrdenCompra: [{nombre, color, tipo, cantidad}] } para la columna Articulos
  const [articulosPorOrden, setArticulosPorOrden] = useState({});
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50

  // L102 (2026-06) — al venir de guardar una OC (OrdenesCompraCreate setea
  // localStorage.autoPDFOrdenCompra), abrir su PDFOC en automático cuando carguen
  // los datos. PDFOC está hoisteada (function declaration) → disponible aquí.
  useEffect(() => {
    const autoPDFId = localStorage.getItem("autoPDFOrdenCompra");
    if (!autoPDFId || !comments || comments.length === 0) return;
    const oc = comments.find((c) => String(c._id) === String(autoPDFId));
    if (oc) {
      localStorage.removeItem("autoPDFOrdenCompra");
      try {
        PDFOC(
          oc.fecha,
          oc.plazo,
          oc.fecha_compromiso,
          oc.idProveedores,
          oc.proveedores,
          oc.total_kilos,
          oc.total_metros,
          oc.total_piezas,
          oc.total_general,
          oc.observaciones,
          oc.numero,
          oc.tipo,
          oc.impuestos,
          oc.empresa,
          oc.dirigido,
          oc._id,
          oc.autorizadoUser,
          oc.lugarEntrega,
          // (2026-07) al crear la OC, además de abrir el PDF, preguntar y enviarlo por correo
          true
        );
      } catch (e) {
        console.warn("No se pudo abrir el PDF automático de la OC:", e);
      }
    }
  }, [comments]);

  useEffect(() => {
    axios
      .get(URL_ORDENES_COMPRA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allOrdenes = response.data;
    // Array para pagination
    let arrayTabla = allOrdenes
    .sort((a, b) => (a.idOrdenCompra < b.idOrdenCompra ? 1 : -1))
    .map((a) => {
      return {
        _id:a._id,
        numero: a.idOrdenCompra,
        activo: a.is_active,
        fecha: a.fecha,
        plazo: a.plazo,
        fecha_compromiso: a.fecha_compromiso,
        // fecha_cita: a.fecha_cita,
        // fecha_cancelacion_pedido: a.fecha_cancelacion_pedido,
        // fecha_creacion_prepedido: a.fecha_creacion_prepedido,
        observaciones: a.observaciones,
        total_general: a.total_general,
        proveedores: a.proveedores[0].nombre_comercial,
        idProveedores: a.proveedores[0]._id,
        nacInt: a.proveedores[0].nacInt,
        // clientes: a.clientes[0].nombre_comercial,
        // idClientes: a.clientes[0]._id,
        total_kilos: a.total_kilos,
        total_metros: a.total_metros,
        total_piezas: a.total_piezas,
        status: a.status,
        tipo:a.tipo,
        autorizado: a.autorizado,
        // T7 (2026-06) — quien autorizó
        autorizadoUser:
          a.autorizadoUser?.[0]?.nombre || a.autorizadoUser?.[0]?.name || "",
        impuestos: a.impuestos,
        empresa: a.empresa,
        dirigido: a.dirigido,
        // L64 (2026-06) — lugar de entrega
        lugarEntrega: a.lugarEntrega || "NA",
        // pendFechaConf: a.pendFechaConf,
      };
    }).filter(function (el) {
      return el != null;
    });

    let dataFinal = Object.values(arrayTabla);

    setOrdenesCompra(allOrdenes);
    setComments(dataFinal)
    //

      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

      // axios
      // .get(URL_CLIENTES, {
      //   headers: {
      //     Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      //   },
      // })
      // .then((response) => {
      //   let allClientes = response.data;
      //   setClientes(allClientes);
      // })
      // .catch((err) => {
      //   console.log(err);
      // });

      axios
      .get(URL_TELAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allTelas = response.data;
        setTelas(allTelas);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
        .get(URL_COLORES, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allColores = res.data;
          setColores(allColores);
        })
        .catch((err) => {
          console.log(err);
        });

      axios
      .get(URL_HABILITACION, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allHabilitacion = response.data;
        setHabilitacion(allHabilitacion);
      })
      .catch((err) => {
        console.log(err);
      });

  }, []);


  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
          (status == 0 ||
            status == a.status) &&
            (selectedProveedor == 0 ||
              selectedProveedor == a.idProveedores)&&
              // (selectedCliente == 0 ||
              //   selectedCliente == a.idClientes)&&
              (selectedTipo == "" ||
                selectedTipo == a.tipo)
      ) {
        return [
          a.numero,
          a.fecha,
          a.proveedores,
          a.tipo,
          // a.clientes,
          a.fecha_compromiso,
          // a.fecha_cita,
          // a.fecha_cancelacion_pedido,
          // a.fecha_creacion_prepedido,
          a.observaciones,
          a.total_kilos,
          a.total_metros,
          a.total_piezas,
          "$" + new Intl.NumberFormat("en-US").format(a.total_general),
         ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Ordenes de Compra`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Proveedor",
          "Tipo",
          // "Cliente",
          "Fecha Comp",
          // "Fecha Cita",
          // "Fecha Canc. Ped.",
          // "Fecha Crea. PrePed.",
          "Observaciones",
          "Kilos",
          "Metros",
          "Piezas",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    // doc.save(`Ordenes-Compra.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
          (status == 0 ||
            status == a.status) &&
            (selectedProveedor == 0 ||
              selectedProveedor == a.idProveedores)&&
              // (selectedCliente == 0 ||
              //   selectedCliente == a.idClientes)&&
              (selectedTipo == "" ||
                selectedTipo == a.tipo)
      ) {
        return {
          Numero:a.numero,
          FechaCreacion: a.fecha,
          Proveedor: a.proveedores,
          Tipo: a.tipo,
          // Cliente: a.clientes,
          FechaComp: a.fecha_compromiso,
          // FechaCita: a.fecha_cita,
          // FechaCancPed: a.fecha_cancelacion_pedido,
          // FechaCreaPrePed: a.fecha_creacion_prepedido,
          Observaciones: a.observaciones,
          Kilos: a.total_kilos,
          Metros: a.total_metros,
          Piezas:a.total_piezas,
          Total: a.total_general,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoOrdenesCompra";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoOrdenesCompra",
        sheetFilter: [
          "Numero",
          "FechaCreacion",
          "Proveedor",
          "Tipo",
          // "Cliente",
          "FechaComp",
          // "FechaCita",
          // "FechaCancPed",
          // "FechaCreaPrePed",
          "Observaciones",
          "Kilos",
          "Metros",
          "Piezas",
          "Total",
        ],
        sheetHeader: [
          "Numero",
          "FechaCreacion",
          "Proveedor",
          "Tipo",
          // "Cliente",
          "FechaComp",
          // "FechaCita",
          // "FechaCancPed",
          // "FechaCreaPrePed",
          "Observaciones",
          "Kilos",
          "Metros",
          "Piezas",
          "Total",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
          (status == 0 ||
            status == a.status) &&
            (selectedProveedor == 0 ||
              selectedProveedor == a.idProveedores)&&
              // (selectedCliente == 0 ||
              //   selectedCliente == a.idClientes)&&
              (selectedTipo == "" ||
                selectedTipo == a.tipo)
      ) {
        return [
          a.numero,
          a.fecha,
          a.proveedores,
          a.tipo,
          // a.clientes,
          a.fecha_compromiso,
          // a.fecha_cita,
          // a.fecha_cancelacion_pedido,
          // a.fecha_creacion_prepedido,
          a.observaciones,
          a.total_kilos,
          a.total_metros,
          a.total_piezas,
          "$" + new Intl.NumberFormat("en-US").format(a.total_general),
         ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Ordenes de Compra`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Proveedor",
          "Tipo",
          // "Cliente",
          "Fecha Comp",
          // "Fecha Cita",
          // "Fecha Canc. Ped.",
          // "Fecha Crea. PrePed.",
          "Observaciones",
          "Kilos",
          "Metros",
          "Piezas",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = doc.output("datauristring").split(",")[1];

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Ordenes Compra",
          email: mailTo,
          fileName: "ListadoOrdenesCompra.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Ordenes de Compra.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    fecha,
    plazo,
    fecha_compromiso,
    // fecha_cita,
    // fecha_cancelacion_pedido,
    // fecha_creacion_prepedido,
    idProveedores,
    // idClientes,
    total_kilos,
    total_metros,
    total_piezas,
    total_general,
    observaciones,
    numero_orden,
    tipo,
    empresa,
    dirigido,
    idEdit,
    // L64 (2026-06)
    lugarEntrega ) {
      setFecha(fecha);
      setPlazo(plazo)
      setFechaCompromiso(fecha_compromiso)
      // setFechaCita(fecha_cita)
      // setFechaCancelacionPedido(fecha_cancelacion_pedido)
      // setFechaCreacionPrePedido(fecha_creacion_prepedido)
      setSelectedProveedorEdit(idProveedores)
      // setSelectedClienteEdit(idClientes)
      setTotalUnidaKilos(total_kilos)
      setTotalUnidaMetros(total_metros)
      setTotalUnidaPiezas(total_piezas)
      setTotalGeneral(total_general)
      setObservaciones(observaciones)
      setNumeroOrden(numero_orden)
      setEmpresa(empresa)
      setDirigido(dirigido)
      // L64 (2026-06) — lugar de entrega
      setLugarEntrega(lugarEntrega || "NA")
      setIdEdit(idEdit);
      toggleEdit();
  }

  let IVAPDF = 0
  let totalPDF = 0
// L104 (2026-06) — usar logoInstitucionDonnatela cuando la empresa es UNIFORMES INNOVACIÓN
function logoInstSrc(empresa) {
  const t =
    typeof empresa === "string"
      ? empresa
      : empresa?.razonSocial || empresa?.name || "";
  const norm = t
    .normalize("NFD")
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .toLowerCase();
  const file = norm.includes("uniformes innovacion")
    ? "logoInstitucionDonnatela.png"
    : "logoInstitucion.png";
  return process.env.PUBLIC_URL + file;
}

// (2026-07) Envío automático del PDFOC por correo.
// Pregunta Sí/No y, si se confirma, manda el PDF (base64) a la lista fija de
// correos + el correo registrado del proveedor, usando el endpoint /sendMailAtt.
const CORREOS_FIJOS_PDFOC = [
  "coleccionesfinas@masesores.com.mx",
  "uniformesinnovacion@masesores.com.mx",
  "alex@langiani.com",
  "administracion@langiani.com",
  // "danysalame18@gmail.com",
  // "admin@lynqro.com"
];
function cuerpoCorreoPDFOC(mensaje) {
  return `<table border="0" cellpadding="0" cellspacing="0" width="100%">
       <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
       <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
       <tbody>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${mensaje}</tr>
       </tbody>
       <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
       <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
       </table>`;
}
async function enviarPDFOCporCorreo(doc, { fileName, asunto, mensaje, proveedorEmail }) {
  const provOk =
    proveedorEmail && /^\S+@\S+\.\S+$/.test(String(proveedorEmail).trim());
  const confirmacion = await Swal.fire({
    title: "¿Enviar el PDFOC por correo?",
    html:
      "Se enviará a Colecciones Finas, Uniformes Innovación, Alex y Administración" +
      (provOk ? ", y al proveedor." : "."),
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Sí, enviar",
    cancelButtonText: "No",
  });
  if (!confirmacion.isConfirmed) return;
  const emails = [...CORREOS_FIJOS_PDFOC];
  if (provOk) emails.push(String(proveedorEmail).trim());
  const base64File = doc.output("datauristring").split(",")[1];
  try {
    await axios.post(
      process.env.REACT_APP_URL_SEND_MAIL_ATT,
      {
        subject: asunto,
        email: emails,
        fileName,
        att: base64File,
        text: cuerpoCorreoPDFOC(mensaje),
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );
    Swal.fire("Enviado", "El PDFOC se envió por correo.", "success");
  } catch (error) {
    console.log(error);
    Swal.fire({
      icon: "error",
      title: "No se pudo enviar",
      text: "Revisa la conexión o los correos de destino.",
    });
  }
}

async function PDFOC(
  fecha,
  plazo,
  fecha_compromiso,
  idProveedores,
  proveedores,
  total_kilos,
  total_metros,
  total_piezas,
  total_general,
  observaciones,
  numero,
  tipo,
  impuestos,
  empresa,
  dirigido,
  idPDFOC,
  // T7 (2026-06)
  autorizadoUser,
  // L64 (2026-06)
  lugarEntrega,
  // (2026-07) cuando viene true (flujo al crear la OC) pregunta y envía el PDFOC por correo
  autoMail = false
) {
function agregarFirmasOC(doc, yFirmas, dirigido) {
  const firmas = [
    {
      centro: 78.5,
      texto: "Firma de Comprador",
    },
    {
      centro: 148.5,
      texto: "Firma Recepción",
    },
    {
      centro: 218.5,
      texto: `Dirigido a: ${dirigido || ""}`,
    },
  ];

  doc.setFontSize(10);

  firmas.forEach((firma) => {
    const anchoLinea = 40;

    // Línea
    doc.line(
      firma.centro - anchoLinea / 2,
      yFirmas,
      firma.centro + anchoLinea / 2,
      yFirmas
    );

    // Texto centrado
    doc.text(firma.texto, firma.centro, yFirmas + 7, {
      align: "center",
    });
  });
}

  let IVAPDF = 0;
  let totalPDF = total_general;

  if (impuestos === "Si") {
    IVAPDF = total_general * 0.16;
    totalPDF = total_general * 1.16;
  }

  // L45 (2026-06) — fetch datos completos de empresa propia y proveedor
  const headersAuth = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };
  let empresaData = null;
  let proveedorData = null;
  try {
    const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
    const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
    const [empRes, provRes] = await Promise.all([
      axios.get(URL_EMPRESAS, { headers: headersAuth }),
      idProveedores
        ? axios.get(`${URL_PROVEEDORES}/${idProveedores}`, { headers: headersAuth })
        : Promise.resolve({ data: null }),
    ]);
    const empresasAll = Array.isArray(empRes?.data) ? empRes.data : [];
    // L103 (2026-06) — match normalizado: ignora acentos, puntuación, mayúsculas
    // y espacios. Así "Colecciones Finas SA de CV" == "COLECCIONES FINAS S.A. DE C.V."
    const norm = (s) =>
      (s || "")
        .toString()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
    const empTarget = norm(empresa);
    if (empTarget) {
      empresaData =
        // 1) coincidencia exacta normalizada (name o razonSocial)
        empresasAll.find(
          (e) => norm(e?.name) === empTarget || norm(e?.razonSocial) === empTarget
        ) ||
        // 2) fallback: que uno contenga al otro (por si difieren un poco)
        empresasAll.find((e) => {
          const n = norm(e?.name);
          const rs = norm(e?.razonSocial);
          return (
            (n && (n.includes(empTarget) || empTarget.includes(n))) ||
            (rs && (rs.includes(empTarget) || empTarget.includes(rs)))
          );
        }) ||
        null;
    }
    // L103 — si no hubo match, deja en consola las empresas disponibles para diagnóstico
    if (!empresaData) {
      console.warn(
        "[OC PDF] empresa no encontrada:",
        empresa,
        "| disponibles:",
        empresasAll.map((e) => e?.razonSocial || e?.name)
      );
    }
    proveedorData = provRes?.data || null;
  } catch (e) {
    console.warn("No se pudo cargar empresa/proveedor", e);
  }

  await axios
    .get(`${URL_TELAS_OC}/ordenesCompra/${idPDFOC}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allTelasOrden = response.data;

      let dataFinal;

      if (tipo === "Tela") {
        const arrayTabla = allTelasOrden
          .map((a) => {
            return {
              id: a._id,
              articulo: a.telas[0].codigo + " " + a.telas[0].nombre,
              descripcion: a.telas[0].tiposTelas[0].name,
              unidad: a.telas[0].unidad,
              colores: a.colores[0].name,
              cantidad: a.cantidad,
              precio: a.precio,
              descuento: a.descuento,
              total: a.total,
              pendiente_recibir: a.pendiente_recibir,
              observaciones: a.observaciones,
            };
          })
          .filter((el) => el != null);

        dataFinal = Object.values(arrayTabla);
      } else {
        const arrayTabla = allTelasOrden
          .map((a) => {
            return {
              id: a._id,
              articulo:
                a.habilitacion[0].nombre +
                " " +
                a.habilitacion[0].descripcion,
              descripcion: a.habilitacion[0].descripcion,
              unidad: a.habilitacion[0].unidad,
              colores: "NA",
              cantidad: a.cantidad,
              precio: a.precio,
              descuento: a.descuento,
              total: a.total,
              pendiente_recibir: a.pendiente_recibir,
              observaciones: a.observaciones,
            };
          })
          .filter((el) => el != null);

        dataFinal = Object.values(arrayTabla);
      }

      const mts = dataFinal.filter((e) => e.unidad == "Metros");

      const TM = mts
        .map((c) => parseFloat(c.cantidad))
        .reduce((t, n) => t + n, 0);

      setTotalMetrosEdit(TM);

      const KG = dataFinal.filter((e) => e.unidad == "Kilos");

      const TK = KG
        .map((c) => parseFloat(c.cantidad))
        .reduce((t, n) => t + n, 0);

      setTotalKilosEdit(TK);

      const PZ = dataFinal.filter((e) => e.unidad == "Piezas");

      const TP = PZ
        .map((c) => parseFloat(c.cantidad))
        .reduce((t, n) => t + n, 0);

      setTotalPiezasEdit(TP);

      const TG = dataFinal
        .map((c) => parseFloat(c.total))
        .reduce((t, n) => t + n, 0);

      setTotalGeneralEdit(TG);

      if (tipo === "Tela") {
        const data = dataFinal.map((a) => {
          return [
            a.articulo,
            a.descripcion,
            a.observaciones,
            a.unidad,
            a.colores,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            "$" + new Intl.NumberFormat("en-US").format(a.precio),
            a.descuento + " %",
            "$" + new Intl.NumberFormat("en-US").format(a.total),
          ];
        });

        const dataPDFLimpia = Object.values(data).filter(
          (el) => el != null
        );

        const doc = new jsPDF("landscape");
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const marginLeft = 15;
        const marginRight = 15;

        // === L45 (2026-06) — Paleta y helpers ===
        // L114 (2026-06) — morado si la empresa es UNIFORMES INNOVACIÓN (logo Donnatela)
        const brandColor = /Donnatela/i.test(logoInstSrc(empresa))
          ? [205, 184, 245]
          : [42, 90, 138];
        const lightBg = [245, 247, 250];
        const borderColor = [210, 216, 224];
        const labelColor = [110, 120, 135];
        const stripeBg = [251, 252, 253];

        const drawLabel = (label, value, lblX, valX, y) => {
          doc.setFont(undefined, "bold");
          doc.setTextColor(...labelColor);
          doc.setFontSize(8.5);
          doc.text(label, lblX, y);
          doc.setFont(undefined, "normal");
          doc.setTextColor(0);
          doc.setFontSize(9.5);
          const txt = String(value ?? "").trim();
          doc.text(txt || "—", valX, y);
        };

        // ============ LOGO IZQ + TÍTULO DER + LÍNEA DIVISORIA ============
        var img2 = new Image();
        img2.src = logoInstSrc(empresa); // L104
        // L115 — Donnatela: logo más grande y sin distorsión (proporción real 1024/494)
        if (/Donnatela/i.test(img2.src)) {
          const hLogo = 18;
          doc.addImage(img2, "png", marginLeft, 8, hLogo * (1024 / 494), hLogo);
        } else {
          doc.addImage(img2, "png", marginLeft, 8, 32, 14);
        }

        doc.setFont(undefined, "bold");
        doc.setFontSize(16);
        doc.setTextColor(...brandColor);
        doc.text(`ORDEN DE COMPRA # ${numero}`, pageWidth - marginRight, 18, { align: "right" });
        doc.setTextColor(0);

        doc.setDrawColor(...brandColor);
        doc.setLineWidth(0.6);
        doc.line(marginLeft, 28, pageWidth - marginRight, 28);
        doc.setLineWidth(0.2);
        doc.setDrawColor(0);

        // ============ CARD 2 COLUMNAS METADATOS ============
        const cardY = 31;
        const cardW = pageWidth - marginLeft - marginRight;
        const cardH = 32;
        doc.setDrawColor(...borderColor);
        doc.setFillColor(...lightBg);
        doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
        doc.setDrawColor(0);

        const lblX_L = marginLeft + 3;
        const valX_L = marginLeft + 28;
        const baseY = cardY + 6;
        drawLabel("Fecha:", fecha, lblX_L, valX_L, baseY);
        drawLabel("Plazo:", `${plazo} días`, lblX_L, valX_L, baseY + 5);
        drawLabel("Compromiso:", fecha_compromiso, lblX_L, valX_L, baseY + 10);
        drawLabel("Tipo:", tipo, lblX_L, valX_L, baseY + 15);
        // T7 (2026-06) — quien autorizó
        drawLabel("Autorizó:", autorizadoUser || "—", lblX_L, valX_L, baseY + 20);

        const colRightX = pageWidth / 2 + 5;
        const lblX_R = colRightX;
        const valX_R = colRightX + 30;
        drawLabel("Metros:", new Intl.NumberFormat("en-US").format(total_metros), lblX_R, valX_R, baseY);
        drawLabel("Kilos:", new Intl.NumberFormat("en-US").format(total_kilos), lblX_R, valX_R, baseY + 5);
        drawLabel("Piezas:", new Intl.NumberFormat("en-US").format(total_piezas), lblX_R, valX_R, baseY + 10);
        drawLabel("Dirigido a:", dirigido, lblX_R, valX_R, baseY + 15);
        // L64 (2026-06) — Entrega en se renderiza al pie del PDF (no en la card)

        let currentY = cardY + cardH + 5;

        // ============ CLIENTE / EMPRESA + PROVEEDOR (2 cajas paralelas) ============
        const halfW = (cardW - 4) / 2;
        const blockH = 30;

        // CLIENTE (empresa propia)
        doc.setFillColor(...brandColor);
        doc.rect(marginLeft, currentY, halfW, 6, "F");
        doc.setTextColor(255, 255, 255);
        doc.setFont(undefined, "bold");
        doc.setFontSize(9.5);
        doc.text("CLIENTE", marginLeft + 3, currentY + 4.2);
        doc.setTextColor(0);
        doc.setFillColor(...lightBg);
        doc.setDrawColor(...borderColor);
        doc.rect(marginLeft, currentY + 6, halfW, blockH - 6, "FD");
        doc.setDrawColor(0);

        const empName = empresaData?.razonSocial || empresa || "";
        const empRFC = empresaData?.rfc || "";
        const empDir = empresaData?.direccionFiscal || "";
        const empCP = empresaData?.cp || "";
        const empReg = empresaData?.regimenFiscal || "";

        doc.setFont(undefined, "bold");
        doc.setFontSize(9.5);
        doc.setTextColor(0);
        doc.text(String(empName), marginLeft + 3, currentY + 11);
        doc.setFont(undefined, "normal");
        doc.setFontSize(8.5);
        doc.setTextColor(...labelColor);
        const empLine2 = [empRFC ? `RFC: ${empRFC}` : "", empReg ? `Rég.: ${empReg}` : ""]
          .filter(Boolean)
          .join("   ·   ");
        if (empLine2) doc.text(empLine2, marginLeft + 3, currentY + 16);
        const empDirLines = doc.splitTextToSize(
          [empDir, empCP ? `C.P. ${empCP}` : ""].filter(Boolean).join(", "),
          halfW - 6
        );
        if (empDirLines.length) doc.text(empDirLines, marginLeft + 3, currentY + 21);
        doc.setTextColor(0);

        // PROVEEDOR
        const provX = marginLeft + halfW + 4;
        doc.setFillColor(...brandColor);
        doc.rect(provX, currentY, halfW, 6, "F");
        doc.setTextColor(255, 255, 255);
        doc.setFont(undefined, "bold");
        doc.setFontSize(9.5);
        doc.text("PROVEEDOR", provX + 3, currentY + 4.2);
        doc.setTextColor(0);
        doc.setFillColor(...lightBg);
        doc.setDrawColor(...borderColor);
        doc.rect(provX, currentY + 6, halfW, blockH - 6, "FD");
        doc.setDrawColor(0);

        const provName = proveedorData?.razon_social || proveedorData?.nombre_comercial || proveedores || "";
        const provRFC = proveedorData?.RFC || "";
        const provTel = proveedorData?.telefono || "";
        const provMail = proveedorData?.email || "";
        const provDir = proveedorData
          ? [
              proveedorData?.calle,
              proveedorData?.numero_ext,
              proveedorData?.colonia,
              proveedorData?.ciudad,
              proveedorData?.estado,
              proveedorData?.cp ? `C.P. ${proveedorData.cp}` : "",
            ]
              .filter((x) => x)
              .join(", ")
          : "";

        doc.setFont(undefined, "bold");
        doc.setFontSize(9.5);
        doc.setTextColor(0);
        doc.text(String(provName), provX + 3, currentY + 11);
        doc.setFont(undefined, "normal");
        doc.setFontSize(8.5);
        doc.setTextColor(...labelColor);
        const provLine2 = [provRFC ? `RFC: ${provRFC}` : "", provTel ? `Tel: ${provTel}` : ""]
          .filter(Boolean)
          .join("   ·   ");
        if (provLine2) doc.text(provLine2, provX + 3, currentY + 16);
        if (provMail) doc.text(`Mail: ${provMail}`, provX + 3, currentY + 21);
        if (provDir) {
          const provDirLines = doc.splitTextToSize(provDir, halfW - 6);
          doc.text(provDirLines, provX + 3, currentY + 26);
        }
        doc.setTextColor(0);

        currentY += blockH + 5;

        const footTela =
          impuestos === "Si"
            ? [
                [
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "SubTotal",
                  "$" +
                    new Intl.NumberFormat("en-US").format(total_general),
                ],
                [
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "IVA",
                  "$" + new Intl.NumberFormat("en-US").format(IVAPDF),
                ],
                [
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "Total",
                  "$" + new Intl.NumberFormat("en-US").format(totalPDF),
                ],
              ]
            : [
                [
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "Total",
                  "$" +
                    new Intl.NumberFormat("en-US").format(total_general),
                ],
              ];

        doc.autoTable({
          head: [
            [
              "Articulo",
              "Descripcion",
              "Observaciones",
              "Unidad",
              "Color",
              "Cantidad",
              "Precio",
              "Descuento",
              "Total",
            ],
          ],
          body: dataPDFLimpia,
          startY: currentY,
          foot: footTela,
          showFoot: "lastPage",
          margin: { left: marginLeft, right: marginRight },
          // L45 (2026-06) — tabla profesional con zebra + brand color
          theme: "grid",
          styles: {
            fontSize: 9,
            cellPadding: 1,
            valign: "middle",
            halign: "center",
            overflow: "linebreak",
            lineColor: borderColor,
            lineWidth: 0.15,
          },
          headStyles: {
            fillColor: brandColor,
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 9.5,
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: stripeBg,
          },
          // L47 (2026-06) — foot: en rama Tela hay 9 columnas; coloreamos
          // sólo las 2 últimas (label + monto).
          footStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            lineColor: [255, 255, 255],
            lineWidth: 0,
          },
          didParseCell: (h) => {
            if (h.section === "foot") {
              const isLastTwo = h.column.index === 7 || h.column.index === 8;
              if (isLastTwo) {
                h.cell.styles.fillColor = brandColor;
                h.cell.styles.textColor = [255, 255, 255];
                h.cell.styles.fontStyle = "bold";
                h.cell.styles.lineColor = brandColor;
                h.cell.styles.lineWidth = 0.15;
              } else {
                h.cell.styles.fillColor = [255, 255, 255];
                h.cell.styles.textColor = [255, 255, 255];
                h.cell.styles.lineColor = [255, 255, 255];
                h.cell.styles.lineWidth = 0;
              }
            }
          },
        });

        // (2026-08) Las observaciones ya no se imprimen en la OC
        let yAfterTable = doc.autoTable.previous.finalY + 6;

        const yFirmas = yAfterTable + 16;
        agregarFirmasOC(doc, yFirmas, dirigido);

        // ============ FOOTER L45 — paginación + L77 Entregar en ============
        const pageCount = doc.internal.getNumberOfPages();
        const entregaTxt =
          lugarEntrega && lugarEntrega !== "—" && lugarEntrega !== "NA"
            ? lugarEntrega
            : "";
        for (let p = 1; p <= pageCount; p++) {
          doc.setPage(p);
          // L77 (2026-06) — Lugar de entrega abajo, encima del footer paginado
          if (entregaTxt) {
            doc.setFontSize(9);
            doc.setFont(undefined, "bold");
            doc.setTextColor(...labelColor);
            doc.text("Entregar en:", marginLeft, pageHeight - 12);
            const labelW = doc.getTextWidth("Entregar en: ");
            doc.setFont(undefined, "normal");
            doc.setTextColor(0);
            const maxW = pageWidth - marginLeft * 2 - labelW;
            const lines = doc.splitTextToSize(entregaTxt, maxW);
            doc.text(lines, marginLeft + labelW, pageHeight - 12);
          }
          doc.setFontSize(8);
          doc.setTextColor(...labelColor);
          doc.text(
            `OC #${numero}  ·  ${empName || empresa || ""}  ·  Página ${p} de ${pageCount}`,
            pageWidth / 2,
            pageHeight - 5,
            { align: "center" }
          );
          doc.setTextColor(0);
        }

        window.open(doc.output("bloburl"), "_blank");
        if (autoMail) {
          enviarPDFOCporCorreo(doc, {
            fileName: `OrdenCompra-${numero || idPDFOC}.pdf`,
            asunto: `Orden de Compra ${numero || ""}`.trim(),
            mensaje: "Adjunto encontrarás la Orden de Compra.",
            proveedorEmail: proveedorData?.email,
          });
        }
      } else {
        const data = dataFinal.map((a) => {
          return [
            a.articulo,
            a.observaciones,
            a.unidad,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            "$" + new Intl.NumberFormat("en-US").format(a.precio),
            a.descuento + " %",
            "$" + new Intl.NumberFormat("en-US").format(a.total),
          ];
        });

        const dataPDFLimpia = Object.values(data).filter(
          (el) => el != null
        );

        const doc = new jsPDF("landscape");
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const marginLeft = 15;
        const marginRight = 15;

        // === L45 (2026-06) — Paleta y helpers (rama Habilitación) ===
        // L114 (2026-06) — morado si la empresa es UNIFORMES INNOVACIÓN (logo Donnatela)
        const brandColor = /Donnatela/i.test(logoInstSrc(empresa))
          ? [205, 184, 245]
          : [42, 90, 138];
        const lightBg = [245, 247, 250];
        const borderColor = [210, 216, 224];
        const labelColor = [110, 120, 135];
        const stripeBg = [251, 252, 253];

        const drawLabel = (label, value, lblX, valX, y) => {
          doc.setFont(undefined, "bold");
          doc.setTextColor(...labelColor);
          doc.setFontSize(8.5);
          doc.text(label, lblX, y);
          doc.setFont(undefined, "normal");
          doc.setTextColor(0);
          doc.setFontSize(9.5);
          const txt = String(value ?? "").trim();
          doc.text(txt || "—", valX, y);
        };

        // ============ HEADER ============
        var img2 = new Image();
        img2.src = logoInstSrc(empresa); // L104
        // L115 — Donnatela: logo más grande y sin distorsión (proporción real 1024/494)
        if (/Donnatela/i.test(img2.src)) {
          const hLogo = 18;
          doc.addImage(img2, "png", marginLeft, 8, hLogo * (1024 / 494), hLogo);
        } else {
          doc.addImage(img2, "png", marginLeft, 8, 32, 14);
        }

        doc.setFont(undefined, "bold");
        doc.setFontSize(16);
        doc.setTextColor(...brandColor);
        doc.text(`ORDEN DE COMPRA # ${numero}`, pageWidth - marginRight, 18, { align: "right" });
        doc.setTextColor(0);

        doc.setDrawColor(...brandColor);
        doc.setLineWidth(0.6);
        doc.line(marginLeft, 28, pageWidth - marginRight, 28);
        doc.setLineWidth(0.2);
        doc.setDrawColor(0);

        // ============ CARD METADATOS ============
        const cardY = 31;
        const cardW = pageWidth - marginLeft - marginRight;
        const cardH = 32;
        doc.setDrawColor(...borderColor);
        doc.setFillColor(...lightBg);
        doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
        doc.setDrawColor(0);

        const lblX_L = marginLeft + 3;
        const valX_L = marginLeft + 28;
        const baseY = cardY + 6;
        drawLabel("Fecha:", fecha, lblX_L, valX_L, baseY);
        drawLabel("Plazo:", `${plazo} días`, lblX_L, valX_L, baseY + 5);
        drawLabel("Compromiso:", fecha_compromiso, lblX_L, valX_L, baseY + 10);
        drawLabel("Tipo:", tipo, lblX_L, valX_L, baseY + 15);
        // T7 (2026-06) — quien autorizó
        drawLabel("Autorizó:", autorizadoUser || "—", lblX_L, valX_L, baseY + 20);

        const colRightX = pageWidth / 2 + 5;
        const lblX_R = colRightX;
        const valX_R = colRightX + 30;
        drawLabel("Metros:", new Intl.NumberFormat("en-US").format(total_metros), lblX_R, valX_R, baseY);
        drawLabel("Kilos:", new Intl.NumberFormat("en-US").format(total_kilos), lblX_R, valX_R, baseY + 5);
        drawLabel("Piezas:", new Intl.NumberFormat("en-US").format(total_piezas), lblX_R, valX_R, baseY + 10);
        drawLabel("Dirigido a:", dirigido, lblX_R, valX_R, baseY + 15);
        // L64 (2026-06) — Entrega en se renderiza al pie del PDF (no en la card)

        let currentY = cardY + cardH + 5;

        // ============ CLIENTE / EMPRESA + PROVEEDOR ============
        const halfW = (cardW - 4) / 2;
        const blockH = 30;

        doc.setFillColor(...brandColor);
        doc.rect(marginLeft, currentY, halfW, 6, "F");
        doc.setTextColor(255, 255, 255);
        doc.setFont(undefined, "bold");
        doc.setFontSize(9.5);
        doc.text("CLIENTE", marginLeft + 3, currentY + 4.2);
        doc.setTextColor(0);
        doc.setFillColor(...lightBg);
        doc.setDrawColor(...borderColor);
        doc.rect(marginLeft, currentY + 6, halfW, blockH - 6, "FD");
        doc.setDrawColor(0);

        const empName = empresaData?.razonSocial || empresa || "";
        const empRFC = empresaData?.rfc || "";
        const empDir = empresaData?.direccionFiscal || "";
        const empCP = empresaData?.cp || "";
        const empReg = empresaData?.regimenFiscal || "";

        doc.setFont(undefined, "bold");
        doc.setFontSize(9.5);
        doc.setTextColor(0);
        doc.text(String(empName), marginLeft + 3, currentY + 11);
        doc.setFont(undefined, "normal");
        doc.setFontSize(8.5);
        doc.setTextColor(...labelColor);
        const empLine2 = [empRFC ? `RFC: ${empRFC}` : "", empReg ? `Rég.: ${empReg}` : ""]
          .filter(Boolean)
          .join("   ·   ");
        if (empLine2) doc.text(empLine2, marginLeft + 3, currentY + 16);
        const empDirLines = doc.splitTextToSize(
          [empDir, empCP ? `C.P. ${empCP}` : ""].filter(Boolean).join(", "),
          halfW - 6
        );
        if (empDirLines.length) doc.text(empDirLines, marginLeft + 3, currentY + 21);
        doc.setTextColor(0);

        const provX = marginLeft + halfW + 4;
        doc.setFillColor(...brandColor);
        doc.rect(provX, currentY, halfW, 6, "F");
        doc.setTextColor(255, 255, 255);
        doc.setFont(undefined, "bold");
        doc.setFontSize(9.5);
        doc.text("PROVEEDOR", provX + 3, currentY + 4.2);
        doc.setTextColor(0);
        doc.setFillColor(...lightBg);
        doc.setDrawColor(...borderColor);
        doc.rect(provX, currentY + 6, halfW, blockH - 6, "FD");
        doc.setDrawColor(0);

        const provName = proveedorData?.razon_social || proveedorData?.nombre_comercial || proveedores || "";
        const provRFC = proveedorData?.RFC || "";
        const provTel = proveedorData?.telefono || "";
        const provMail = proveedorData?.email || "";
        const provDir = proveedorData
          ? [
              proveedorData?.calle,
              proveedorData?.numero_ext,
              proveedorData?.colonia,
              proveedorData?.ciudad,
              proveedorData?.estado,
              proveedorData?.cp ? `C.P. ${proveedorData.cp}` : "",
            ]
              .filter((x) => x)
              .join(", ")
          : "";

        doc.setFont(undefined, "bold");
        doc.setFontSize(9.5);
        doc.setTextColor(0);
        doc.text(String(provName), provX + 3, currentY + 11);
        doc.setFont(undefined, "normal");
        doc.setFontSize(8.5);
        doc.setTextColor(...labelColor);
        const provLine2 = [provRFC ? `RFC: ${provRFC}` : "", provTel ? `Tel: ${provTel}` : ""]
          .filter(Boolean)
          .join("   ·   ");
        if (provLine2) doc.text(provLine2, provX + 3, currentY + 16);
        if (provMail) doc.text(`Mail: ${provMail}`, provX + 3, currentY + 21);
        if (provDir) {
          const provDirLines = doc.splitTextToSize(provDir, halfW - 6);
          doc.text(provDirLines, provX + 3, currentY + 26);
        }
        doc.setTextColor(0);

        currentY += blockH + 5;

        const footNoTela =
          impuestos === "Si"
            ? [
                [
                  "",
                  "",
                  "",
                  "",
                  "",
                  "SubTotal",
                  "$" +
                    new Intl.NumberFormat("en-US").format(total_general),
                ],
                [
                  "",
                  "",
                  "",
                  "",
                  "",
                  "IVA",
                  "$" + new Intl.NumberFormat("en-US").format(IVAPDF),
                ],
                [
                  "",
                  "",
                  "",
                  "",
                  "",
                  "Total",
                  "$" + new Intl.NumberFormat("en-US").format(totalPDF),
                ],
              ]
            : [
                [
                  "",
                  "",
                  "",
                  "",
                  "",
                  "Total",
                  "$" +
                    new Intl.NumberFormat("en-US").format(total_general),
                ],
              ];

        doc.autoTable({
          head: [
            [
              "Articulo",
              "Observaciones",
              "Unidad",
              "Cantidad",
              "Precio",
              "Descuento",
              "Total",
            ],
          ],
          body: dataPDFLimpia,
          startY: currentY,
          foot: footNoTela,
          showFoot: "lastPage",
          margin: { left: marginLeft, right: marginRight },
          // L45 (2026-06)
          theme: "grid",
          styles: {
            fontSize: 9,
            cellPadding: 1,
            valign: "middle",
            halign: "center",
            overflow: "linebreak",
            lineColor: borderColor,
            lineWidth: 0.15,
          },
          headStyles: {
            fillColor: brandColor,
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 9.5,
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: stripeBg,
          },
          // L47 (2026-06) — foot: en rama Habilitación hay 7 columnas; coloreamos
          // sólo las 2 últimas (label + monto).
          footStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            lineColor: [255, 255, 255],
            lineWidth: 0,
          },
          didParseCell: (h) => {
            if (h.section === "foot") {
              const isLastTwo = h.column.index === 5 || h.column.index === 6;
              if (isLastTwo) {
                h.cell.styles.fillColor = brandColor;
                h.cell.styles.textColor = [255, 255, 255];
                h.cell.styles.fontStyle = "bold";
                h.cell.styles.lineColor = brandColor;
                h.cell.styles.lineWidth = 0.15;
              } else {
                h.cell.styles.fillColor = [255, 255, 255];
                h.cell.styles.textColor = [255, 255, 255];
                h.cell.styles.lineColor = [255, 255, 255];
                h.cell.styles.lineWidth = 0;
              }
            }
          },
        });

        // (2026-08) Las observaciones ya no se imprimen en la OC
        let yAfterTable = doc.autoTable.previous.finalY + 6;

        const yFirmas = yAfterTable + 16;
        agregarFirmasOC(doc, yFirmas, dirigido);

        // ============ FOOTER L45 ============
        const pageCount = doc.internal.getNumberOfPages();
        for (let p = 1; p <= pageCount; p++) {
          doc.setPage(p);
          doc.setFontSize(8);
          doc.setTextColor(...labelColor);
          doc.text(
            `OC #${numero}  ·  ${empName || empresa || ""}  ·  Página ${p} de ${pageCount}`,
            pageWidth / 2,
            pageHeight - 5,
            { align: "center" }
          );
          doc.setTextColor(0);
        }

        window.open(doc.output("bloburl"), "_blank");
        if (autoMail) {
          enviarPDFOCporCorreo(doc, {
            fileName: `OrdenCompra-${numero || idPDFOC}.pdf`,
            asunto: `Orden de Compra ${numero || ""}`.trim(),
            mensaje: "Adjunto encontrarás la Orden de Compra.",
            proveedorEmail: proveedorData?.email,
          });
        }
      }
    })
    .catch((err) => {
      console.log(err);
    });
}

  function editOrdenes(event) {
    event.preventDefault();
    const URL_ORDENES_COMPRA_EDIT = `${process.env.REACT_APP_URL_ORDENES_COMPRA}/${idEdit}`;

            axios.patch(
              URL_ORDENES_COMPRA_EDIT,
              {
                fecha,
                plazo,
                fecha_compromiso,
                // fecha_cita,
                // fecha_cancelacion_pedido,
                // fecha_creacion_prepedido,
                proveedores: selectedProveedorEdit,
                // clientes: selectedClienteEdit,
                observaciones,
                empresa,
                dirigido,
                // L64 (2026-06)
                lugarEntrega
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Orden deCompra",
                detalle: `${numero_orden} ${fecha}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
           
            toggleEdit();
            Swal.fire("Good job!", "Actualizado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
  }


  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha Creacion", field: "fecha", sortable: false },
    { name: "Proveedor", field: "proveedores", sortable: false },
    // { name: "NacInt", field: "nacInt", sortable: false },
    { name: "Tipo", field: "tipo", sortable: false },
    // { name: "Cliente", field: "clientes", sortable: false },
    // { name: "Pend Fecha Conf", field: "pendFechaConf", sortable: false },
    { name: "Compromiso", field: "fecha_compromiso", sortable: true },
    // { name: "Cita", field: "fecha_cita", sortable: true },
    // { name: "Cancelacion Ped", field: "fecha_cancelacion_pedido", sortable: true },
    // { name: "Creacion PrePedido", field: "fecha_creacion_prepedido", sortable: true },
    { name: "Observaciones", field: "observaciones", sortable: true },
    // (2026-08) artículos (telas / habilitación) que trae la orden
    { name: "Articulos", field: "articulos", sortable: false },
    { name: "Kilos", field: "total_kilos", sortable: true },
    { name: "Metros", field: "total_metros", sortable: true },
    { name: "Piezas", field: "total_piezas", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    // T7 (2026-06)
    { name: "Autorizó", field: "autorizadoUser", sortable: false },
    { name: "Acciones", field: "acciones", sortable: false },
    { name: "Editar", field: "editar", sortable: false },
];

  // (2026-08) Artículos (telas / habilitación) de cada orden, para la columna del
  // listado. Se piden en bloques para no armar URLs enormes.
  useEffect(() => {
    const ids = [...new Set(comments.map((c) => c._id).filter(Boolean))].map(
      String
    );

    if (!ids.length) {
      setArticulosPorOrden({});
      return;
    }

    let cancelado = false;
    const bloques = [];
    for (let i = 0; i < ids.length; i += 60) bloques.push(ids.slice(i, i + 60));

    Promise.all(
      bloques.map((b) =>
        axios
          .get(`${URL_TELAS_OC}/articulosOrdenes/${b.join(",")}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((r) => r.data || {})
          .catch((err) => {
            console.log("articulosOrdenes err:", err);
            return {};
          })
      )
    ).then((partes) => {
      if (cancelado) return;
      const mapa = {};
      partes.forEach((p) =>
        Object.keys(p).forEach((k) => {
          mapa[k] = p[k] || [];
        })
      );
      setArticulosPorOrden(mapa);
    });

    return () => {
      cancelado = true;
    };
  }, [comments]);

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.proveedores.toLowerCase().includes(search.toLowerCase()) ||
          // comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          // comment.nacInt.toLowerCase().includes(search.toLowerCase()) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          // comment.pendFechaConf.toLowerCase().includes(search.toLowerCase()) ||
          comment.total_kilos.toString().includes(search) ||
          comment.total_metros.toString().includes(search) ||
          comment.total_piezas.toString().includes(search) ||
          comment.total_general.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          // (2026-08) artículos de la orden (tela / habilitación y color)
          (articulosPorOrden[comment._id] || [])
            .map((art) => `${art.nombre} ${art.color}`)
            .join(" ")
            .toLowerCase()
            .includes(search.toLowerCase())
      );
    }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedores.includes(selectedProveedor)
      );
    }
    // if(selectedCliente){
    //   computedComments = computedComments.filter((e)=>
    //   e.idClientes.includes(selectedCliente)
    //   )
    // }
    // if(selectedPendFechaConf){
    //   computedComments = computedComments.filter((e)=>
    //   e.pendFechaConf.includes(selectedPendFechaConf)
    //   )
    // }
    if (status) {
      computedComments = computedComments.filter((e) =>
        e.status.includes(status)
      );
    }
    if (autorizado) {
      computedComments = computedComments.filter((e) =>
        e.autorizado.includes(autorizado)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    if (selectedFechaCompInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha_compromiso >= selectedFechaCompInicio
      );
    }

    if (selectedFechaCompFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha_compromiso <= selectedFechaCompFin
      );
    }
    if (selectedTipo) {
      computedComments = computedComments.filter((e) =>
        e.tipo.includes(selectedTipo)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_kilos" &&
      sorting.field != "total_metros" &&
      sorting.field != "total_piezas" &&
      sorting.field != "total_general" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total_kilos" ||
        sorting.field == "total_metros" ||
        sorting.field == "total_piezas" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total_kilos" ||
        sorting.field == "total_metros" ||
        sorting.field == "total_piezas" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    status,
    autorizado,
    selectedFechaInicio,
    selectedFechaFin,
    selectedProveedor,
    // selectedCliente,
    // selectedPendFechaConf,
    selectedTipo,
    articulosPorOrden,
  ]);


function EditTelas(idOC, numero_orden, tipo){
  setTipo(tipo)
  setInputFields([
    {
      id: uuidv4(),
      telas: "",
      unidad: 0,
      colores: "",
      // arrayColoresTela:[],
      cantidad: 0,
      precio: 0,
      descuento: 0,
      total: 0,
      observaciones: "NA"
    },
  ])
  setIdEdit(idOC)
  setNumeroOrden(numero_orden)
  if(tipo=="Tela"){
  axios
  .get(`${URL_TELAS_OC}/ordenesCompra/${idOC}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allTelasOrden = response.data
    let arrayTabla = allTelasOrden
    .map((a) => {
      return {
        id:a._id,
        telas: a.telas[0]._id,
        unidad: a.telas[0].unidad,
        colores: a.colores[0]._id,
        // arrayColoresTela:a.telas[0].colores,
        cantidad: a.cantidad,
        precio: a.precio,
        descuento: a.descuento,
        total: a.total,
        pendiente_recibir: a.pendiente_recibir,
        observaciones: a.observaciones
      };
    }).filter(function (el) {
      return el != null;
    });
    var dataFinal = Object.values(arrayTabla);  
    setTelasOrden(dataFinal)


    let mts = dataFinal.filter(e=>e.unidad == "Metros")
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetrosEdit(TM);
    let KG = dataFinal.filter(e=>e.unidad == "Kilos")
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilosEdit(TK);
    let PZ = dataFinal.filter(e=>e.unidad == "Piezas")
    let totalPZ = PZ.map((c) => parseFloat(c.cantidad));
    let TP = totalPZ.reduce((t, total, index) => t + total, 0);
    setTotalPiezasEdit(TP);
    let importes = dataFinal.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  })
  .catch((err) => {
    console.log(err);
  });
  toggleEditTelas()} else{
    
  axios
  .get(`${URL_TELAS_OC}/ordenesCompra/${idOC}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allTelasOrden = response.data
    let arrayTabla = allTelasOrden
    .map((a) => {
      return {
        id:a._id,
        habilitacion: a.habilitacion[0]._id,
        unidad: a.habilitacion[0].unidad,
        cantidad: a.cantidad,
        precio: a.precio,
        descuento: a.descuento,
        total: a.total,
        pendiente_recibir: a.pendiente_recibir,
        observaciones: a.observaciones
      };
    }).filter(function (el) {
      return el != null;
    });
    var dataFinal = Object.values(arrayTabla);  
    setHabilitacionOrden(dataFinal)

    let mts = dataFinal.filter(e=>e.unidad == "Metros")
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetrosEdit(TM);
    let KG = dataFinal.filter(e=>e.unidad == "Kilos")
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilosEdit(TK);

    let PZ = dataFinal.filter(e=>e.unidad == "Piezas")
    let totalPZ = PZ.map((c) => parseFloat(c.cantidad));
    let TP = totalPZ.reduce((t, total, index) => t + total, 0);
    setTotalPiezasEdit(TP);
    let importes = dataFinal.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  })
  .catch((err) => {
    console.log(err);
  });
  toggleEditHabilitacion()
  }
}

const handleChangeInputExistentes = (id, event) => {
  const newTelasOrden = telasOrden.map((i) => {
    if (id === i.id) {
      i[event.target.name] = event.target.value;
      let totalParcial = i.cantidad * i.precio;
      i.total = (totalParcial - (totalParcial * i.descuento) / 100).toFixed(2);
    }
    return i;
  });
  setTelasOrden(newTelasOrden);
  ActualizaTotales()
};

const handleChangeInputExistentesHab = (id, event) => {
  const newHabilitacionOrden = habilitacionOrden.map((i) => {
    if (id === i.id) {
      i[event.target.name] = event.target.value;
      let totalParcial = i.cantidad * i.precio;
      i.total = (totalParcial - (totalParcial * i.descuento) / 100).toFixed(2);
    }
    return i;
  });
  setHabilitacionOrden(newHabilitacionOrden);
  ActualizaTotalesHab()
};

const handleChangeInputExistentesCantidad = (id, event) => {
  const newTelasOrden = telasOrden.map((i) => {
    if (id === i.id) {
      let PR = parseFloat(i.pendiente_recibir) - parseFloat(i.cantidad) + parseFloat(event.target.value)
      i.pendiente_recibir = PR
      i[event.target.name] = event.target.value;
      let totalParcial = i.cantidad * i.precio;
      i.total = (totalParcial - (totalParcial * i.descuento) / 100).toFixed(2);
    }
    return i;
  });
  setTelasOrden(newTelasOrden);
  ActualizaTotales()
};

const handleChangeInputExistentesCantidadHab = (id, event) => {
  const newHabilitacionOrden = habilitacionOrden.map((i) => {
    if (id === i.id) {
      let PR = parseFloat(i.pendiente_recibir) - parseFloat(i.cantidad) + parseFloat(event.target.value)
      i.pendiente_recibir = PR
      i[event.target.name] = event.target.value;
      let totalParcial = i.cantidad * i.precio;
      i.total = (totalParcial - (totalParcial * i.descuento) / 100).toFixed(2);
    }
    return i;
  });
  setHabilitacionOrden(newHabilitacionOrden);
  ActualizaTotalesHab()
};


function BuscaTelaExistentes(id, event){
  telas.map((a)=>{
    if(a._id == event.target.value){
      let idTela = a._id
      let unidadTela = a.unidad
      let coloresTela = a.colores
      handleChangeInputExistentesTela(id, idTela, unidadTela, coloresTela)
    }
  })
}

const handleChangeInputExistentesTela = (id, idTela, unidadTela, coloresTela) => {
  const newTelasOrden = telasOrden.map((i) => {
    if (id === i.id) {
      i.telas = idTela;
      i.unidad = unidadTela
      // i.arrayColoresTela = coloresTela
      let totalParcial = i.cantidad * i.precio;
      i.total = (totalParcial - (totalParcial * i.descuento) / 100).toFixed(2);
    }
    return i;
  });
  setTelasOrden(newTelasOrden);
  ActualizaTotales()
};

function BuscaHabilitacionExistentes(id, event){
  habilitacion.map((a)=>{
    if(a._id == event.target.value){
      let idHabilitacion = a._id
      let unidadHabilitacion = a.unidad
      handleChangeInputExistentesHabilitacion(id, idHabilitacion, unidadHabilitacion)
    }
  })
}

const handleChangeInputExistentesHabilitacion = (id, idHabilitacion, unidadHabilitacion) => {
  const newHabilitacionOrden = habilitacionOrden.map((i) => {
    if (id === i.id) {
      i.Habilitacions = idHabilitacion;
      i.unidad = unidadHabilitacion
      let totalParcial = i.cantidad * i.precio;
      i.total = (totalParcial - (totalParcial * i.descuento) / 100).toFixed(2);
    }
    return i;
  });
  setHabilitacionOrden(newHabilitacionOrden);
  ActualizaTotalesHab()
};

const handleAddFields = () => {
  const ultimo = inputFields[inputFields.length-1];
  setInputFields([
    ...inputFields,
    {
      id: uuidv4(),
      telas: ultimo.telas,
      unidad: ultimo.unidad,
      colores: ultimo.colores,
      // arrayColoresTela: ultimo.arrayColoresTela,
      cantidad: 0,
      precio: ultimo.precio,
      descuento: ultimo.descuento,
      total: 0,
      observaciones: "NA"
    },
  ]);
};

const handleAddFieldsHab = () => {
  const ultimo = inputFieldsHab[inputFieldsHab.length-1];
  setInputFieldsHab([
    ...inputFieldsHab,
    {
      id: uuidv4(),
      habilitacion: ultimo.habilitacion,
      unidad: ultimo.unidad,
      cantidad: 0,
      precio: ultimo.precio,
      descuento: ultimo.descuento,
      total: 0,
      observaciones: "NA"
    },
  ]);
};

const handleRemoveFields = (id) => {
  const values = [...inputFields];
  values.splice(
    values.findIndex((value) => value.id === id),
    1
  );
  setInputFields(values);
  let mtsExistentes = telasOrden.filter(e=>e.unidad == "Metros")
  let mtsNuevos = values.filter(e=>e.unidad == "Metros")
  let mts = mtsExistentes.concat(mtsNuevos)
  let totalMts = mts.map((c) => parseFloat(c.cantidad));
  let TM = totalMts.reduce((t, total, index) => t + total, 0);
  setTotalMetrosEdit(TM);

  let KGExistentes = telasOrden.filter(e=>e.unidad == "Kilos")
  let KGNuevos = values.filter(e=>e.unidad == "Kilos")
  let KG = KGExistentes.concat(KGNuevos)
  let totalKG = KG.map((c) => parseFloat(c.cantidad));
  let TK = totalKG.reduce((t, total, index) => t + total, 0);
  setTotalKilosEdit(TK);

  let PZExistentes = telasOrden.filter(e=>e.unidad == "Piezas")
  let PZNuevos = values.filter(e=>e.unidad == "Piezas")
  let PZ = PZExistentes.concat(PZNuevos)
  let totalPZ = PZ.map((c) => parseFloat(c.cantidad));
  let TP = totalPZ.reduce((t, total, index) => t + total, 0);
  setTotalPiezasEdit(TP);
  
  let importesExistentes = telasOrden.map((c) => parseFloat(c.total));
  let importesNuevos = values.map((c) => parseFloat(c.total));
  let importes = importesExistentes.concat(importesNuevos)
  let TG = importes.reduce((t, total, index) => t + total, 0);
  setTotalGeneralEdit(TG);

};

const handleRemoveFieldsHab = (id) => {
  const values = [...inputFieldsHab];
  values.splice(
    values.findIndex((value) => value.id === id),
    1
  );
  setInputFieldsHab(values);
  let mtsExistentes = habilitacionOrden.filter(e=>e.unidad == "Metros")
  let mtsNuevos = values.filter(e=>e.unidad == "Metros")
  let mts = mtsExistentes.concat(mtsNuevos)
  let totalMts = mts.map((c) => parseFloat(c.cantidad));
  let TM = totalMts.reduce((t, total, index) => t + total, 0);
  setTotalMetrosEdit(TM);

  let KGExistentes = habilitacionOrden.filter(e=>e.unidad == "Kilos")
  let KGNuevos = values.filter(e=>e.unidad == "Kilos")
  let KG = KGExistentes.concat(KGNuevos)
  let totalKG = KG.map((c) => parseFloat(c.cantidad));
  let TK = totalKG.reduce((t, total, index) => t + total, 0);
  setTotalKilosEdit(TK);

  let PZExistentes = habilitacionOrden.filter(e=>e.unidad == "Piezas")
  let PZNuevos = values.filter(e=>e.unidad == "Piezas")
  let PZ = PZExistentes.concat(PZNuevos)
  let totalPZ = PZ.map((c) => parseFloat(c.cantidad));
  let TP = totalPZ.reduce((t, total, index) => t + total, 0);
  setTotalPiezasEdit(TP);
  
  let importesExistentes = habilitacionOrden.map((c) => parseFloat(c.total));
  let importesNuevos = values.map((c) => parseFloat(c.total));
  let importes = importesExistentes.concat(importesNuevos)
  let TG = importes.reduce((t, total, index) => t + total, 0);
  setTotalGeneralEdit(TG);

};

const handleChangeInput = (id, event) => {
  const newInputFields = inputFields.map((i) => {
    if (id === i.id) {
      i[event.target.name] = event.target.value;
      let totalParcial = i.cantidad * i.precio;
      i.total = (totalParcial - (totalParcial * i.descuento) / 100).toFixed(2);
    }
    return i;
  });
  setInputFields(newInputFields);
  ActualizaTotales()
};

const handleChangeInputHab = (id, event) => {
  const newInputFieldsHab = inputFieldsHab.map((i) => {
    if (id === i.id) {
      i[event.target.name] = event.target.value;
      let totalParcial = i.cantidad * i.precio;
      i.total = (totalParcial - (totalParcial * i.descuento) / 100).toFixed(2);
    }
    return i;
  });
  setInputFieldsHab(newInputFieldsHab);
  ActualizaTotalesHab()
};

function BuscaTela(id, event){
  telas.map((a)=>{
    if(a._id == event.target.value){
      let idTela = a._id
      let unidadTela = a.unidad
      let coloresTela = a.colores
      handleChangeInputTela(id, idTela, unidadTela, coloresTela)
    }
  })
}


const handleChangeInputTela = (id, idTela, unidadTela, coloresTela) => {
  const newInputFields = inputFields.map((i) => {
    if (id === i.id) {
      i.telas = idTela;
      i.unidad = unidadTela
      // i.arrayColoresTela = coloresTela
      let totalParcial = i.cantidad * i.precio;
      i.total = (totalParcial - (totalParcial * i.descuento) / 100).toFixed(2);
    }
    return i;
  });
  setInputFields(newInputFields);
  ActualizaTotales()
};


function BuscaHabilitacion(id, event){
  habilitacion.map((a)=>{
    if(a._id == event.target.value){
      let idHabilitacion = a._id
      let unidadHabilitacion = a.unidad
      handleChangeInputHabilitacion(id, idHabilitacion, unidadHabilitacion)
    }
  })
}

const handleChangeInputHabilitacion = (id, idHabilitacion, unidadHabilitacion) => {
  const newInputFieldsHab = inputFieldsHab.map((i) => {
    if (id === i.id) {
      i.habilitacion = idHabilitacion;
      i.unidad = unidadHabilitacion
      let totalParcial = i.cantidad * i.precio;
      i.total = (totalParcial - (totalParcial * i.descuento) / 100).toFixed(2);
    }
    return i;
  });
  setInputFieldsHab(newInputFieldsHab);
  ActualizaTotalesHab()
};


function ActualizaTotales(){
      let mtsExistentes = telasOrden.filter(e=>e.unidad == "Metros")
      let mtsNuevos = inputFields.filter(e=>e.unidad == "Metros")
      let mts = mtsExistentes.concat(mtsNuevos)
      let totalMts = mts.map((c) => parseFloat(c.cantidad));
      let TM = totalMts.reduce((t, total, index) => t + total, 0);
      setTotalMetrosEdit(TM);

      let KGExistentes = telasOrden.filter(e=>e.unidad == "Kilos")
      let KGNuevos = inputFields.filter(e=>e.unidad == "Kilos")
      let KG = KGExistentes.concat(KGNuevos)
      let totalKG = KG.map((c) => parseFloat(c.cantidad));
      let TK = totalKG.reduce((t, total, index) => t + total, 0);
      setTotalKilosEdit(TK);

      let PZExistentes = telasOrden.filter(e=>e.unidad == "Piezas")
      let PZNuevos = inputFields.filter(e=>e.unidad == "Piezas")
      let PZ = PZExistentes.concat(PZNuevos)
      let totalPZ = PZ.map((c) => parseFloat(c.cantidad));
      let TP = totalPZ.reduce((t, total, index) => t + total, 0);
      setTotalPiezasEdit(TP);
      
      let importesExistentes = telasOrden.map((c) => parseFloat(c.total));
      let importesNuevos = inputFields.map((c) => parseFloat(c.total));
      let importes = importesExistentes.concat(importesNuevos)
      let TG = importes.reduce((t, total, index) => t + total, 0);
      setTotalGeneralEdit(TG);
}

function ActualizaTotalesHab(){
  let mtsExistentes = habilitacionOrden.filter(e=>e.unidad == "Metros")
  let mtsNuevos = inputFieldsHab.filter(e=>e.unidad == "Metros")
  let mts = mtsExistentes.concat(mtsNuevos)
  let totalMts = mts.map((c) => parseFloat(c.cantidad));
  let TM = totalMts.reduce((t, total, index) => t + total, 0);
  setTotalMetrosEdit(TM);

  let KGExistentes = habilitacionOrden.filter(e=>e.unidad == "Kilos")
  let KGNuevos = inputFieldsHab.filter(e=>e.unidad == "Kilos")
  let KG = KGExistentes.concat(KGNuevos)
  let totalKG = KG.map((c) => parseFloat(c.cantidad));
  let TK = totalKG.reduce((t, total, index) => t + total, 0);
  setTotalKilosEdit(TK);

  let PZExistentes = habilitacionOrden.filter(e=>e.unidad == "Piezas")
  let PZNuevos = inputFieldsHab.filter(e=>e.unidad == "Piezas")
  let PZ = PZExistentes.concat(PZNuevos)
  let totalPZ = PZ.map((c) => parseFloat(c.cantidad));
  let TP = totalPZ.reduce((t, total, index) => t + total, 0);
  setTotalPiezasEdit(TP);
  
  let importesExistentes = habilitacionOrden.map((c) => parseFloat(c.total));
  let importesNuevos = inputFieldsHab.map((c) => parseFloat(c.total));
  let importes = importesExistentes.concat(importesNuevos)
  let TG = importes.reduce((t, total, index) => t + total, 0);
  setTotalGeneralEdit(TG);
}



const saveOrdenCompra = async (event) => {
  event.preventDefault();
  const URL_ORDENES_COMPRA_EDIT = `${process.env.REACT_APP_URL_ORDENES_COMPRA}/${idEdit}`;
  try {
    await axios
      .patch(
        URL_ORDENES_COMPRA_EDIT,
        {
          total_general:total_general_edit,
          total_kilos:total_kilos_edit,
          total_piezas:total_piezas_edit,
          total_metros:total_metros_edit
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        inputFields.map((a) => {
          axios.post(
            URL_TELAS_OC,
            {
              ordenesCompra: idEdit,
              telas: a.telas,
              colores: a.colores,
              cantidad: parseFloat(a.cantidad),
              recibido: 0,
              pendiente_recibir: parseFloat(a.cantidad),
              precio: parseFloat(a.precio),
              descuento: parseFloat(a.descuento),
              total: parseFloat(a.total),
              observaciones: a.observaciones,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
        })
        telasOrden.map((a)=>{
          axios.patch(
            `${URL_TELAS_OC}/${a.id}`,
            {
              telas: a.telas,
              colores: a.colores,
              cantidad: parseFloat(a.cantidad),
              precio: parseFloat(a.precio),
              descuento: parseFloat(a.descuento),
              total: parseFloat(a.total),
              pendiente_recibir: parseFloat(a.pendiente_recibir),
              observaciones: a.observaciones,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
        })
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Orden de Compra",
            detalle: `${numero_orden}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", `success`);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `${error.response.data}`,
    });
    console.log(error);
  }
};

const saveOrdenCompraHab = async (event) => {
  event.preventDefault();
  const URL_ORDENES_COMPRA_EDIT = `${process.env.REACT_APP_URL_ORDENES_COMPRA}/${idEdit}`;
  try {
    await axios
      .patch(
        URL_ORDENES_COMPRA_EDIT,
        {
          total_general:total_general_edit,
          total_kilos:total_kilos_edit,
          total_piezas:total_piezas_edit,
          total_metros:total_metros_edit
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        inputFieldsHab.map((a) => {
          axios.post(
            URL_TELAS_OC,
            {
              ordenesCompra: idEdit,
              habilitacion: a.habilitacion,
              cantidad: parseFloat(a.cantidad),
              recibido: 0,
              pendiente_recibir: parseFloat(a.cantidad),
              precio: parseFloat(a.precio),
              descuento: parseFloat(a.descuento),
              total: parseFloat(a.total),
              observaciones: a.observaciones,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
        })
        habilitacionOrden.map((a)=>{
          axios.patch(
            `${URL_TELAS_OC}/${a.id}`,
            {
              habilitacion: a.habilitacion,
              cantidad: parseFloat(a.cantidad),
              precio: parseFloat(a.precio),
              descuento: parseFloat(a.descuento),
              total: parseFloat(a.total),
              pendiente_recibir: parseFloat(a.pendiente_recibir),
              observaciones: a.observaciones,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
        })
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Orden de Compra",
            detalle: `${numero_orden}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", `success`);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `${error.response.data}`,
    });
    console.log(error);
  }
};


function desautorizar(idEdit) {
  Swal.fire({
    title: "Estas seguro?",
    text: "Se quitara la autorizacion!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, quitar autorizacion!",
  }).then((result) => {
    if (result.isConfirmed) {
      axios
        .patch(
          `${URL_ORDENES_COMPRA}/${idEdit}`,
          {
            autorizado: "No",
            // T7 (2026-06) — limpiar autorizadoUser
            autorizadoUser: [],
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((response) => {
          const newComments = comments.map((i) => {
            if (idEdit === i._id) {
              i.autorizado = "No";
              i.autorizadoUser = "";
            }
            return i;
          });
          setComments(newComments);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se quito la autorizacion",
            showConfirmButton: false,
            timer: 2000,
          });
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    }
  });
}

function autorizar(idEdit) {
  Swal.fire({
    title: "Estas seguro?",
    text: "Se va a autorizar!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, autorizar!",
  }).then((result) => {
    if (result.isConfirmed) {
      axios
        .patch(
          `${URL_ORDENES_COMPRA}/${idEdit}`,
          {
            autorizado: "Si",
            // T7 (2026-06) — registrar quién autorizó
            autorizadoUser: [user.id],
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((response) => {
          const newComments = comments.map((i) => {
            if (idEdit === i._id) {
              i.autorizado = "Si";
              i.autorizadoUser = user.nombre || user.name || "";
            }
            return i;
          });
          setComments(newComments);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se Autorizo",
            showConfirmButton: false,
            timer: 2000,
          });
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    }
  });
}

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_oc ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.oc_create ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/OrdenesCompraCreate"
                >
                  Nueva Orden
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva Orden
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuCompras"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                {user.oc_pdf && (
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                )}
                {user.oc_email && (
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                )}
                {user.oc_excel && (
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                )}
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ordenes de Compra</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Ordenes de Compra</h3>
          <div className="row">
                        <div className="col-md-8">
                            <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
                        <div className="col-md-4 d-flex flex-row-reverse">
                            <Search
                                onSearch={value => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                }}
                            />
                        </div>
                    </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
          
            <Col md={2}>
              <Label>Status</Label>
              <Input
                bsSize="sm"
                type="select"
                value={status}
                required
                onChange={(e) => {
                  setStatus(e.target.value)
                  setCurrentPage(1)
                }}
              >
                <option value="">Selecciona</option>
                <option value="Abierto">Abierto</option>
                <option value="Cerrado">Cerrado</option>
              </Input>
            </Col>

            <Col md={2}>
              <Label>Autorizado</Label>
              <Input
                bsSize="sm"
                type="select"
                value={autorizado}
                required
                onChange={(e) => {
                  setAutorizado(e.target.value)
                  setCurrentPage(1)
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </Col>
          </Row>
            <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader headers={headers} onSorting={(field, order) => setSorting({ field, order }) } />
            <tr>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedProveedor}
                onChange={(e) => {
                  setSelectedProveedor(e.target.value)
                  setCurrentPage(1)
                }}
              >
                <option value="0">Selecciona</option>
                {proveedores
                  .sort((a, b) => (a.razon_social > b.razon_social ? 1 : -1))
                  .map((a) => {
                      if(a.tipo == "Proveedor"){
                    return <option value={a._id}>{a.razon_social}</option>;
                      }
                  })}
              </Input>
              </td>
              {/* <td></td> */}
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedTipo}
                onChange={(e) => {
                  setSelectedTipo(e.target.value)
                  setCurrentPage(1)
                }}
              >
                <option value="">Selecciona</option>
                <option value="Tela">Tela</option>
                <option value="Habilitacion">Habilitacion</option>
                    {/* <option value="Prenda">Prenda</option> */}
              </Input>
              </td>
              {/* <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value)
                  setCurrentPage(1)
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedPendFechaConf}
                onChange={(e) => {
                  setSelectedPendFechaConf(e.target.value)
                  setCurrentPage(1)
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
              </td> */}
            </tr>
            <tbody>
              {commentsData.map((a) => {
                // if(
                //   (a.nacInt == "Internacional" && validadorInter >= a.fecha_compromiso && a.status == "Abierto") ||
                //   (a.nacInt == "Nacional" && validadorNac >= a.fecha_compromiso && a.status == "Abierto")
                //   ){
                  return (
                    // <tr style={{ backgroundColor: "#ed8c8c"}}>
                    <tr>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.proveedores}</td>
                      {/* <td>{a.nacInt}</td> */}
                      <td>{a.tipo}</td>
                      {/* <td>{a.clientes}</td>
                      <td>{a.pendFechaConf}</td> */}
                      <td>{a.fecha_compromiso}</td>
                      {/* <td>{a.fecha_cita}</td>
                      <td>{a.fecha_cancelacion_pedido}</td>
                      <td>{a.fecha_creacion_prepedido}</td> */}
                      <td>{a.observaciones}</td>
                      {/* (2026-08) artículos de la orden (tela/habilitación, color y cantidad) */}
                      <td style={{ minWidth: 170 }}>
                        {(articulosPorOrden[a._id] || []).length ? (
                          (articulosPorOrden[a._id] || []).map((art, i) => (
                            <div key={i} title={art.tipo || ""}>
                              {art.nombre}
                              {art.color ? ` ${art.color}` : ""}
                              {art.cantidad
                                ? ` (${new Intl.NumberFormat("en-US").format(
                                    art.cantidad
                                  )})`
                                : ""}
                            </div>
                          ))
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                      <td>{new Intl.NumberFormat("en-US").format(a.total_kilos)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.total_metros)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.total_piezas)}</td>
                      <td>{"$" + new Intl.NumberFormat("en-US").format(a.total_general)} </td>
                      {/* T7 (2026-06) — quién autorizó */}
                      <td>
                        {a.autorizado === "Si" ? (
                          <span style={{ fontSize: "12px" }}>
                            {a.autorizadoUser || "—"}
                          </span>
                        ) : (
                          <span className="text-muted" style={{ fontSize: "12px" }}>—</span>
                        )}
                      </td>
                      <td>
                        {user.oc_create ? (
                          <div>
                           {user.oc_autorizacion ? (
                             <>
                             {a.autorizado == "Si" ? (
                                  <span>
                                    <Button
                                      color="primary"
                                      id="Baja"
                                      onClick={(e) =>
                                        desautorizar(
                                          a._id
                                        )
                                      }
                                      size="sm"
                                    >
                                      <i class="fas fa-user-check"></i>
                                    </Button>
                                  </span>
                                ) : (
                                  <span>
                                    <Button
                                      color="danger"
                                      onClick={(e) =>
                                        autorizar(
                                          a._id
                                        )
                                      }
                                      size="sm"
                                    >
                                      <i class="fas fa-user-lock"></i>
                                    </Button>
                                  </span>
                                )}
                             </>
                           ) : (undefined)}

                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) => PDFOC(
                                a.fecha,
                                a.plazo,
                                a.fecha_compromiso,
                                // a.fecha_cita,
                                a.idProveedores,
                                a.proveedores,
                                // a.clientes,
                                a.total_kilos,
                                a.total_metros,
                                a.total_piezas,
                                a.total_general,
                                a.observaciones,
                                a.numero,
                                a.tipo,
                                a.impuestos,
                                a.empresa,
                                a.dirigido,
                                a._id,
                                // T7 (2026-06)
                                a.autorizadoUser,
                                // L64 (2026-06)
                                a.lugarEntrega )}
                            ><i class="far fa-file-pdf"></i>
                            </Button>
                            
                             
                            <StatusMultiple
                              idStatus={a._id}
                              status={a.status}
                              URL_STATUS={process.env.REACT_APP_URL_ORDENES_COMPRA}
                              hijo={`${process.env.REACT_APP_URL_TELAS_OC}/baja`}
                            />
                          </div>
                        ) : undefined}
                        </td>
                        <td>
                        { a.status == "Abierto" ?(
                          <div>
                                      <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      onClick={(e) => jalaInfo(  
                                        a.fecha,
                                        a.plazo,
                                        a.fecha_compromiso,
                                        // a.fecha_cita,
                                        // a.fecha_cancelacion_pedido,
                                        // a.fecha_creacion_prepedido,
                                        a.idProveedores,
                                        // a.idClientes,
                                        a.total_kilos,
                                        a.total_metros,
                                        a.total_piezas,
                                        a.total_general,
                                        a.observaciones,
                                        a.numero,
                                        a.tipo,
                                        a.empresa,
                                        a.dirigido,
                                        a._id,
                                        // L64 (2026-06)
                                        a.lugarEntrega )}
                                      >
                                      <i class="far fa-edit"></i>
                                      </Button>
                                      <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      onClick={(e) => EditTelas(a._id, a.numero, a.tipo)}
                                      >
                                      <i class="fas fa-cart-plus"></i>
                                      </Button>
                                      </div>
                              ): (
                                <div>
                                  <Button color="info" id="Editar" size="sm" disabled>
                                    <i class="far fa-edit"></i>
                                  </Button>
                                  <Button
                                      color="info"
                                      id="Editar"
                                      size="sm" disabled>
                                      <i class="fas fa-cart-plus"></i>
                                      </Button>
                                </div>
                              )}
                      </td>
                    </tr>
                  );
                // }else{
                //   return (
                //     <tr>
                //       <td>{a.numero}</td>
                //       <td>{a.fecha}</td>
                //       <td>{a.proveedores}</td>
                //       <td>{a.nacInt}</td>
                //       <td>{a.tipo}</td>
                //       {/* <td>{a.clientes}</td>
                //       <td>{a.pendFechaConf}</td> */}
                //       <td>{a.fecha_compromiso}</td>
                //       {/* <td>{a.fecha_cita}</td>
                //       <td>{a.fecha_cancelacion_pedido}</td>
                //       <td>{a.fecha_creacion_prepedido}</td> */}
                //       <td>{a.observaciones}</td>
                //       <td>
                //         {new Intl.NumberFormat("en-US").format(a.total_kilos)}
                //       </td>
                //       <td>
                //         {new Intl.NumberFormat("en-US").format(a.total_metros)}
                //       </td>
                //       <td>
                //         {new Intl.NumberFormat("en-US").format(a.total_piezas)}
                //       </td>
                //       <td>
                //         {"$" +
                //           new Intl.NumberFormat("en-US").format(
                //             a.total_general
                //           )}{" "}
                //       </td>
                //       <td>
                //         {user.oc_create ? (
                //           <div>
                //             {user.oc_autorizacion ? (
                //               <>
                //                 {a.autorizado == "Si" ? (
                //                   <span>
                //                     <Button
                //                       color="primary"
                //                       id="Baja"
                //                       onClick={(e) =>
                //                         desautorizar(
                //                           a._id
                //                         )
                //                       }
                //                       size="sm"
                //                     >
                //                       <i class="fas fa-user-check"></i>
                //                     </Button>
                //                   </span>
                //                 ) : (
                //                   <span>
                //                     <Button
                //                       color="danger"
                //                       onClick={(e) =>
                //                         autorizar(
                //                           a._id
                //                         )
                //                       }
                //                       size="sm"
                //                     >
                //                       <i class="fas fa-user-lock"></i>
                //                     </Button>
                //                   </span>
                //                 )}
                //               </>
                //             ) : undefined}
                //             {a.autorizado == "Si" ? (
                //               <Button
                //                 size="sm"
                //                 className="btn"
                //                 color="danger"
                //                 onClick={(e) =>
                //                   PDFOC(
                //                     a.fecha,
                //                     a.plazo,
                //                     a.fecha_compromiso,
                //                     // a.fecha_cita,
                //                     a.idProveedores,
                //                     a.proveedores,
                //                     // a.clientes,
                //                     a.total_kilos,
                //                     a.total_metros,
                //                     a.total_piezas,
                //                     a.total_general,
                //                     a.observaciones,
                //                     a.numero,
                //                     a.tipo,
                //                     a.impuestos,
                //                     a.empresa,
                //                     a._id
                //                   )
                //                 }
                //               >
                //                 <i class="far fa-file-pdf"></i>
                //               </Button>
                //             ) : (
                //               <Button
                //                 size="sm"
                //                 className="btn"
                //                 color="danger"
                //                 disabled
                //               >
                //                 <i class="far fa-file-pdf"></i>
                //               </Button>
                //             )}
                //             <StatusMultiple
                //               idStatus={a._id}
                //               status={a.status}
                //               URL_STATUS={
                //                 process.env.REACT_APP_URL_ORDENES_COMPRA
                //               }
                //               hijo={`${process.env.REACT_APP_URL_TELAS_OC}/baja`}
                //             />
                //           </div>
                //         ) : undefined}
                //       </td>
                //       <td>
                //         {a.status == "Abierto" ? (
                //           <div>
                //             <Button
                //               color="info"
                //               id="Editar"
                //               size="sm"
                //               onClick={(e) =>
                //                 jalaInfo(
                //                   a.fecha,
                //                   a.plazo,
                //                   a.fecha_compromiso,
                //                   // a.fecha_cita,
                //                   // a.fecha_cancelacion_pedido,
                //                   // a.fecha_creacion_prepedido,
                //                   a.idProveedores,
                //                   // a.idClientes,
                //                   a.total_kilos,
                //                   a.total_metros,
                //                   a.total_piezas,
                //                   a.total_general,
                //                   a.observaciones,
                //                   a.numero,
                //                   a.tipo,
                //                   a.empresa,
                //                   a._id
                //                 )
                //               }
                //             >
                //               <i class="far fa-edit"></i>
                //             </Button>
                //             <Button
                //               color="info"
                //               id="Editar"
                //               size="sm"
                //               onClick={(e) =>
                //                 EditTelas(a._id, a.numero, a.tipo)
                //               }
                //             >
                //               <i class="fas fa-cart-plus"></i>
                //             </Button>
                //           </div>
                //         ) : (
                //           <div>
                //             <Button color="info" id="Editar" size="sm" disabled>
                //               <i class="far fa-edit"></i>
                //             </Button>
                //             <Button color="info" id="Editar" size="sm" disabled>
                //               <i class="fas fa-cart-plus"></i>
                //             </Button>
                //           </div>
                //         )}
                //       </td>
                //     </tr>
                //   );
                // }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
                            <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
        </div>
      ) : undefined}
      <br />


      

      <Modal size="xxl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>
            Editar Orden de Compra {numero_orden}
          </h4>
        </ModalHeader>
        <ModalBody>
        <Row>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  disabled
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Proveedor</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedProveedorEdit}
                  required
                  onChange={(e) => {
                    setSelectedProveedorEdit(e.target.value);
                  }}
                >
                  <option value="">Selecciona un Proveedor</option>
                  {proveedores
                    .sort((a, b) => (a.razon_social > b.razon_social ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.razon_social}</option>;
                    })}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Plazo</Label>
                <Input
                  type="text"
                  placeholder="Plazo"
                  value={plazo}
                  required
                  onChange={(e) => {
                    setPlazo(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Fecha Compromiso</Label>
                <Input
                  type="date"
                  placeholder="Fecha Compromiso"
                  value={fecha_compromiso}
                  required
                  onChange={(e) => {
                    setFechaCompromiso(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Empresa</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={empresa}
                  required
                  onChange={(e) => {
                    setEmpresa(e.target.value)
                  }}
                >
                  <option value="Langiani SA de CV">Langiani SA de CV</option>
                  <option value="Colecciones Finas SA de CV">Colecciones Finas SA de CV</option>
                  <option value="Uniformes Innovación SA de CV">Uniformes Innovación SA de CV</option>
                </Input>
              </Col>
              <Col md={2}>
                <Label>Dirigido A</Label>
                <Input
                  className="col-sm-12"
                  type="text"
                  value={dirigido}
                  required
                  onChange={(e) => {
                    setDirigido(e.target.value)
                  }}
                />
              </Col>
              {/* L64 (2026-06) — lugar de entrega */}
              <Col md={3}>
                <Label>Lugar de Entrega</Label>
                <Input
                  className="col-sm-12"
                  type="text"
                  value={lugarEntrega}
                  onChange={(e) => {
                    setLugarEntrega(e.target.value);
                  }}
                />
              </Col>
              {/* <Col md={2}>
                <Label>Fecha Cita Recibo</Label>
                <Input
                  type="date"
                  placeholder="Fecha Cita"
                  value={fecha_cita}
                  required
                  onChange={(e) => {
                    setFechaCita(e.target.value);
                  }}
                />
              </Col> */}
            </Row>
            <Row>
            {/* <Col md={2}>
                <Label className="mr-sm-2">Cliente</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedClienteEdit}
                  required
                  onChange={(e) => {
                    setSelectedClienteEdit(e.target.value);
                  }}
                >
                  <option value="">Selecciona un Cliente</option>
                  {clientes
                    .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.nombre_comercial}</option>;
                    })}
                </Input>
              </Col>

              <Col md={2}>
                <Label>Fecha Canc. Pedido</Label>
                <Input
                  type="date"
                  placeholder="Fecha Cita"
                  value={fecha_cancelacion_pedido}
                  required
                  onChange={(e) => {
                    setFechaCancelacionPedido(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Fecha Creacion PrePedido</Label>
                <Input
                  type="date"
                  placeholder="Fecha Cita"
                  value={fecha_creacion_prepedido}
                  required
                  onChange={(e) => {
                    setFechaCreacionPrePedido(e.target.value);
                  }}
                />
              </Col> */}
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" 
          onClick={editOrdenes}
          >
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="xxl" isOpen={modalEditTelas} toggle={toggleEditTelas}>
            <ModalHeader toggle={toggleEditTelas}>
              <h4>Editar Telas OC {numero_orden}</h4>
              <h4>
              TOTALES {total_kilos_edit.toFixed(2)} kg. / {total_metros_edit.toFixed(2)} mts. / {total_piezas_edit.toFixed(2)} pzas. / {"$" + new Intl.NumberFormat("en-US").format(total_general_edit.toFixed(2))}
              </h4>
              </ModalHeader>
            <ModalBody>
            <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Articulo</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Unidad</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Colores</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Cantidad</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Precio</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Descuento</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Observaciones</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Total</Label>
                </Col>
              </Row>

              {telasOrden.map((ao) => (
                <div key={ao.id}>
                  <Row>
                    <Col md={2}>
                      <Input
                        // bsSize="sm"
                        name="telas"
                        type="select"
                        value={ao.telas}
                        required
                        onChange={(event)=>{BuscaTelaExistentes(ao.id, event)}}
                      >
                        <option value="0">Selecciona</option>
                        {telas
                          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                          .map((a) => {
                            return (
                              <option value={a._id}>
                                {a.nombre} / {a.tiposTelas[0].name}
                              </option>
                            );
                          })}
                      </Input>
                    </Col>
                    <Col md={1}>
                        <Input
                        //  bsSize="sm"
                          name="unidad"
                          type="string"
                          value={ao.unidad}
                          disabled
                        >
                        </Input>
                      </Col>
                      {tipo=="Tela"?(
                    <Col md={2}>
                      <Input
                        // bsSize="sm"
                        name="colores"
                        type="select"
                        value={ao.colores}
                        required
                        onChange={(event) =>
                          handleChangeInputExistentes(ao.id, event)
                        }
                      >
                        <option value="0">Selecciona</option>
                        {/* {ao.arrayColoresTela */}
                        {colores
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                            return <option value={a._id}>{a.name}</option>;
                          })}
                      </Input>
                    </Col>
                      ):undefined}

                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="cantidad"
                        type="number"
                        placeholder="Cantidad"
                        value={ao.cantidad}
                        required
                        onChange={(event) =>
                          handleChangeInputExistentesCantidad(ao.id, event)
                        }
                      />
                    </Col>

                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="precio"
                        type="number"
                        placeholder="Precio"
                        value={ao.precio}
                        required
                        onChange={(event) =>
                          handleChangeInputExistentes(ao.id, event)
                        }
                      />
                    </Col>

                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="descuento"
                        type="number"
                        placeholder="Descuento"
                        value={ao.descuento}
                        required
                        onChange={(event) =>
                          handleChangeInputExistentes(ao.id, event)
                        }
                      />
                    </Col>
                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="observaciones"
                        type="text"
                        placeholder="observaciones"
                        value={ao.observaciones}
                        required
                        onChange={(event) =>
                          handleChangeInputExistentes(ao.id, event)
                        }
                      />
                    </Col>
                    <Col md={2}>
                      <Input
                        // bsSize="sm"
                        name="total"
                        type="number"
                        placeholder="Total"
                        value={ao.total}
                        disabled
                        onChange={(event) =>
                          handleChangeInputExistentes(ao.id, event)
                        }
                      />
                    </Col>
                  </Row>
                </div>
              ))}

              {/* Agregar mas telas */}

              {inputFields.map((inputField) => (
                <div key={inputField.id}>
                  <Row>
                    <Col md={2}>
                      <Input
                        // bsSize="sm"
                        name="telas"
                        type="select"
                        value={inputField.telas}
                        required
                        onChange={(event)=>{BuscaTela(inputField.id, event)}}
                      >
                        <option value="0">Selecciona</option>
                        {telas
                          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                          .map((a) => {
                            return (
                              <option value={a._id}>
                                {a.nombre} / {a.tiposTelas[0].name}
                              </option>
                            );
                          })}
                      </Input>
                    </Col>
                    <Col md={1}>
                        <Input
                        //  bsSize="sm"
                          name="unidad"
                          type="string"
                          value={inputField.unidad}
                          disabled
                        >
                        </Input>
                      </Col>
                    <Col md={2}>
                      <Input
                        // bsSize="sm"
                        name="colores"
                        type="select"
                        value={inputField.colores}
                        required
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      >
                        <option value="0">Selecciona</option>
                        {/* {inputField.arrayColoresTela */}
                        {colores
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                            return <option value={a._id}>{a.name}</option>;
                          })}
                      </Input>
                    </Col>

                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="cantidad"
                        type="number"
                        placeholder="Cantidad"
                        value={inputField.cantidad}
                        required
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      />
                    </Col>

                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="precio"
                        type="number"
                        placeholder="Precio"
                        value={inputField.precio}
                        required
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      />
                    </Col>

                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="descuento"
                        type="number"
                        placeholder="Descuento"
                        value={inputField.descuento}
                        required
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      />
                    </Col>
                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="observaciones"
                        type="text"
                        placeholder="observaciones"
                        value={inputField.observaciones}
                        required
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      />
                    </Col>

                    <Col md={2}>
                      <Input
                        // bsSize="sm"
                        name="total"
                        type="number"
                        placeholder="Total"
                        value={inputField.total}
                        disabled
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      />
                    </Col>
                    <Col>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        disabled={inputFields.length === 1}
                        onClick={() => handleRemoveFields(inputField.id)}
                        tabindex="-1"
                      >
                        <i class="fas fa-minus"></i>
                      </Button>
                      <Button 
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                      >
                      <i class="fas fa-plus"></i>
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}
              <Row>
              <Col md={6}>
              <h4 id="logoutBoton">
              TOTALES {total_kilos_edit.toFixed(2)} kg. / {total_metros_edit.toFixed(2)} mts. / {total_piezas_edit.toFixed(2)} pzas. / {"$" + new Intl.NumberFormat("en-US").format(total_general_edit.toFixed(2))}
              </h4>
              </Col>
              </Row>
             
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" 
              onClick={saveOrdenCompra}
              >
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          <Modal size="xxl" isOpen={modalEditHabilitacion} toggle={toggleEditHabilitacion}>
            <ModalHeader toggle={toggleEditHabilitacion}>
              <h4>Editar Articulos OC {numero_orden}</h4>
              <h4>
              TOTALES {total_kilos_edit.toFixed(2)} kg. / {total_metros_edit.toFixed(2)} mts. / {total_piezas_edit.toFixed(2)} pzas. / {"$" + new Intl.NumberFormat("en-US").format(total_general_edit.toFixed(2))}
              </h4>
              </ModalHeader>
            <ModalBody>
            <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Articulo</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Unidad</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Cantidad</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Precio</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Descuento</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Observaciones</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Total</Label>
                </Col>
              </Row>

              {habilitacionOrden.map((ao) => (
                <div key={ao.id}>
                  <Row>
                    <Col md={2}>
                      <Input
                        // bsSize="sm"
                        name="habilitacion"
                        type="select"
                        value={ao.habilitacion}
                        required
                        onChange={(event)=>{BuscaHabilitacionExistentes(ao.id, event)}}
                      >
                        <option value="0">Selecciona</option>
                        {habilitacion
                          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                          .map((a) => {
                            return (
                              <option value={a._id}> {a.nombre} / {a.descripcion} </option>
                            );
                          })}
                      </Input>
                    </Col>
                    <Col md={1}>
                        <Input
                        //  bsSize="sm"
                          name="unidad"
                          type="string"
                          value={ao.unidad}
                          disabled
                        >
                        </Input>
                      </Col>

                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="cantidad"
                        type="number"
                        placeholder="Cantidad"
                        value={ao.cantidad}
                        required
                        onChange={(event) =>
                          handleChangeInputExistentesCantidadHab(ao.id, event)
                        }
                      />
                    </Col>

                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="precio"
                        type="number"
                        placeholder="Precio"
                        value={ao.precio}
                        required
                        onChange={(event) =>
                          handleChangeInputExistentesHab(ao.id, event)
                        }
                      />
                    </Col>

                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="descuento"
                        type="number"
                        placeholder="Descuento"
                        value={ao.descuento}
                        required
                        onChange={(event) =>
                          handleChangeInputExistentesHab(ao.id, event)
                        }
                      />
                    </Col>
                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="observaciones"
                        type="text"
                        placeholder="observaciones"
                        value={ao.observaciones}
                        required
                        onChange={(event) =>
                          handleChangeInputExistentesHab(ao.id, event)
                        }
                      />
                    </Col>
                    <Col md={2}>
                      <Input
                        // bsSize="sm"
                        name="total"
                        type="number"
                        placeholder="Total"
                        value={ao.total}
                        disabled
                        onChange={(event) =>
                          handleChangeInputExistentesHab(ao.id, event)
                        }
                      />
                    </Col>
                  </Row>
                </div>
              ))}

              {/* Agregar mas habilitacion */}

              {inputFieldsHab.map((inputFieldHab) => (
                <div key={inputFieldHab.id}>
                  <Row>
                    <Col md={2}>
                      <Input
                        // bsSize="sm"
                        name="habilitacion"
                        type="select"
                        value={inputFieldHab.habilitacion}
                        required
                        onChange={(event)=>{BuscaHabilitacion(inputFieldHab.id, event)}}
                      >
                        <option value="0">Selecciona</option>
                        {habilitacion
                          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                          .map((a) => {
                            return (
                              <option value={a._id}> {a.nombre} / {a.descripcion}
                              </option>
                            );
                          })}
                      </Input>
                    </Col>
                    <Col md={1}>
                        <Input
                        //  bsSize="sm"
                          name="unidad"
                          type="string"
                          value={inputFieldHab.unidad}
                          disabled
                        >
                        </Input>
                      </Col>

                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="cantidad"
                        type="number"
                        placeholder="Cantidad"
                        value={inputFieldHab.cantidad}
                        required
                        onChange={(event) =>
                          handleChangeInputHab(inputFieldHab.id, event)
                        }
                      />
                    </Col>

                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="precio"
                        type="number"
                        placeholder="Precio"
                        value={inputFieldHab.precio}
                        required
                        onChange={(event) =>
                          handleChangeInputHab(inputFieldHab.id, event)
                        }
                      />
                    </Col>

                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="descuento"
                        type="number"
                        placeholder="Descuento"
                        value={inputFieldHab.descuento}
                        required
                        onChange={(event) =>
                          handleChangeInputHab(inputFieldHab.id, event)
                        }
                      />
                    </Col>

                    <Col md={1}>
                      <Input
                        // bsSize="sm"
                        name="observaciones"
                        type="text"
                        placeholder="observaciones"
                        value={inputFieldHab.observaciones}
                        required
                        onChange={(event) =>
                          handleChangeInputHab(inputFieldHab.id, event)
                        }
                      />
                    </Col>

                    <Col md={2}>
                      <Input
                        // bsSize="sm"
                        name="total"
                        type="number"
                        placeholder="Total"
                        value={inputFieldHab.total}
                        disabled
                        onChange={(event) =>
                          handleChangeInputHab(inputFieldHab.id, event)
                        }
                      />
                    </Col>
                    <Col>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        disabled={inputFieldsHab.length === 1}
                        onClick={() => handleRemoveFieldsHab(inputFieldHab.id)}
                        tabindex="-1"
                      >
                        <i class="fas fa-minus"></i>
                      </Button>
                      <Button 
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFieldsHab}
                      tabindex="-1"
                      >
                      <i class="fas fa-plus"></i>
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}
              <Row>
              <Col md={6}>
              <h4 id="logoutBoton">
              TOTALES {total_kilos_edit.toFixed(2)} kg. / {total_metros_edit.toFixed(2)} mts. / {total_piezas_edit.toFixed(2)} pzas. / {"$" + new Intl.NumberFormat("en-US").format(total_general_edit.toFixed(2))}
              </h4>
              </Col>
              </Row>
             
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" 
              onClick={saveOrdenCompraHab}
              >
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

      {loader}
    </>
  );
}

export default ListadoOrdenesCompra;
